import { render } from "./DevActivity.vue?vue&type=template&id=e5dfab9a&scoped=true"
import script from "./DevActivity.vue?vue&type=script&lang=js"
export * from "./DevActivity.vue?vue&type=script&lang=js"

import "./DevActivity.vue?vue&type=style&index=0&id=e5dfab9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5dfab9a"]])

export default __exports__